import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M7 6V3a1 1 0 011-1h12a1 1 0 011 1v14a1 1 0 01-1 1h-3v3a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1h3zM5 8v12h10V8H5zm4-2h8v10h2V4H9v2z"/>
    <path fill="#34CEFF" d="M13 11H7v2h6v-2zM13 15H7v2h6v-2z"/>
  </SvgIcon>
);